import { Navigate, Route, Routes } from 'react-router-dom';

/**
 * Compatibility redirects for the retired member-specific portal routes.
 * Member navigation now lives under the shared role-aware routes.
 */
export default function MemberDashboard() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/hub" replace />} />
      <Route path="workouts" element={<Navigate to="/workouts" replace />} />
      <Route path="leaderboard" element={<Navigate to="/leaderboard" replace />} />
      <Route path="events" element={<Navigate to="/events" replace />} />
      <Route path="profile" element={<Navigate to="/settings" replace />} />
      <Route path="*" element={<Navigate to="/hub" replace />} />
    </Routes>
  );
}
